import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ReactDOM from 'react-dom';

class AddColumnButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.onClick();
  }
  
  render() {
    const { children, gridApi } = this.props;

    if (gridApi) {
      const gridCore = gridApi.gridCore || gridApi.gos;
      if (gridCore) {
        const el = gridCore.eGridDiv;
        if (el) {
          const list = el.getElementsByClassName('ag-side-bar');
          if (list && list.length > 0) {

            const e = ReactDOM.createPortal(
              (
                <div className="ag-side-buttons-add">
                  <div className="ag-side-button">
                    <button className="ag-button ag-side-button-button" type="button" onClick={this.handleClick}>
                      <div className="ag-side-button-icon-wrapper"><span className="ag-icon ag-icon-plus"></span></div>
                      <span className="ag-side-button-label">{children}</span>
                    </button>
                  </div>
                </div>
              ),
              list[0],
            );

            return e;

          }
        }
      }
    }

    return (
      <Button
        bsStyle="link"
        onClick={this.handleClick}
      >
        {children}
      </Button>
    );
  }
}


AddColumnButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  gridApi: PropTypes.shape({}),
};
AddColumnButton.defaultProps = {
  onClick: () => {},
  children: null,
  gridApi: null,
};

export default AddColumnButton;
